<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('item.invest') }}
      </div>
    </div>
    <div
      v-if="acc"
      class="product"
    >
      <div class="thumb">
        <div class="act">
          <div class="tit">
            {{ $t('investdetail.accba') }}
          </div>
          <div class="val">
            {{ $formatPen(acc.money) }}
          </div>
        </div>
        <div
          class="img"
          @click="$router.push('/moneybag')"
        >
          <img
            src="../images/shop2/invest_bg.png"
            draggable="false"
          >
        </div>
      </div>
      <div class="infos">
        <div class="inf">
          <div class="tit">
            {{ $t('investdetail.startamount') }}
          </div>
          <div class="val">
            {{ data.min }}
          </div>
        </div>
        <div class="inf">
          <div class="tit">
            {{ $t('investdetail.maxamount') }}
          </div>
          <div class="val">
            {{ data.max }}
          </div>
        </div>
        <div class="inf">
          <div class="tit">
            {{ $t('investdetail.cycle') }}
          </div>
          <div class="val">
            {{ data.day }} {{ $t('investdetail.days') }}
          </div>
        </div>
        <div class="inf">
          <div class="tit">
            {{ $t('investdetail.dailyrate') }}
          </div>
          <div class="val">
            {{ data.rate }} %
          </div>
        </div>
      </div>
      <div class="submit">
        <div class="input">
          <div class="uni-input">
            <div class="uni-input-wrapper">
              <input
                v-model="number"
                maxlength="12"
                type="number"
                class="uni-input-input"
              >
            </div>
          </div>
          <span @click="maxnum()">{{ $t('investdetail.maxamountbtn') }}</span>
        </div>
        <!-- <div class="input">
		            <div>
		                <div class="uni-input-wrapper">
		                    <div class="uni-input-placeholder ph">Security password</div>
		                    <input maxlength="140" step="" enterkeyhint="done" autocomplete="off" type="password"
		                           class="uni-input-input"></div>
		            </div>
		        </div> -->
        <div class="earning">
          {{ number*1 }} + {{ number }} * {{ (data.rate/100).toFixed(4) }} * {{ data.day }} = {{ (number*1+number*data.rate/100*data.day).toFixed(2) }}
        </div>
        <div class="button ">
          <span
            class=""
            @click="buy()"
          >{{ $t('investdetail.participate') }}</span>
        </div>
      </div>
      <div class="content">
        <div class="tit">
          {{ $t('investdetail.rules') }}
        </div>
        <div class="col">
          <span>{{ $t('investdetail.projectamount') }}:</span>
          <span>{{ data.total }} USDT</span>
        </div>
        <div class="col">
          <span>{{ $t('investdetail.repayment') }}:</span>
          <span>{{ $t('investdetail.returrnprincipal') }}</span>
        </div>
        <div class="col">
          <span>{{ $t('investdetail.startamount') }}:</span>
          <span>{{ data.min }} USDT</span>
        </div>
        <div class="col">
          <span>{{ $t('investdetail.dailyprofit') }}:</span><span>{{ data.rate }} %</span>
        </div>
        <div class="col">
          <span>{{ $t('investdetail.releasecycle') }}:</span>
          <span>{{ data.day }} {{ $t('investdetail.automaticsettlement') }}</span>
        </div>
        <div class="col">
          <span>{{ $t('investdetail.estimatedincome') }}:</span>
          <span>{{ data.min }} + {{ data.min }}  * {{ data.rate }}% * {{ data.day }} {{ $t('investdetail.estimatedincome') }} {{ (data.min*1 + data.min*data.rate*data.day/100).toFixed(2) }} USDT</span>
        </div>
      </div>
    </div>
		
		
		
    <!-- 
		<div class="item_img"><img :src="data.img"/></div>
		<div class="items_3">
			<div class="item">
				<div class="item_div1">
					<p>
						{{data.title}}
					</p>
				</div>
				<div class="item_div2">
					<div class="item_rate">
						<p>{{$formatPen(data.day_income)}}</p>
						<p>{{$t('utils.dailyIncome')}}</p>
					</div>
					<div class="item_day">
						<p>{{data.day}}{{$t('utils.day')}}</p>
						<p>{{$t('utils.cycle')}}</p>
					</div>
					<div class="item_min">
						<p>{{$formatPen(data.price)}}</p>
						<p>{{$t('utils.startingAmount')}}</p>
					</div>
				</div>
				<div v-if="data.percent" class="item_div4">
					<van-progress :percentage="data.percent" />
				</div>
				<div class="item_btn">
					<button v-if="data.percent<100" type="button" @click="buy(i)">{{$t('utils.invest')}}</button>
					<button class="item_btn_over" v-if="data.percent>=100" type="button">{{$t('utils.investOver')}}</button>
				</div>
			</div>
			<div class="item_content" v-html="data.content"></div>
		</div>
		<van-dialog
		v-model="show_tz" 
		show-cancel-button
		@confirm="confirm"
		:confirmButtonText="$t('utils.confirm')"
		:cancelButtonText="$t('utils.cancel')"
		>
		<div class="items_3">
			<div class="item">
				<div class="item_div1">
					<p>
						{{data.title}}
					</p>
				</div>
				<div class="item_div2">
					<div class="item_rate">
						<p>{{$formatPen(data.day_income)}}</p>
						<p>{{$t('utils.dailyIncome')}}</p>
					</div>
					<div class="item_day">
						<p>{{data.day}}{{$t('utils.day')}}</p>
						<p>{{$t('utils.cycle')}}</p>
					</div>
					<div class="item_min">
						<p>{{$formatPen(data.price)}}</p>
						<p>{{$t('utils.startingAmount')}}</p>
					</div>
				</div>
				<div class="item_div2" v-if="vip">
					<div class="item_rate">
						<p> + {{vip.rate}}% </p>
						<p>{{$t('vip.irates')}}</p>
					</div>
					<div class="item_day">
						<p>{{vip.name}}</p>
						<p>{{$t('vip.title')}}</p>
					</div>
					<div class="item_min">
						<p>{{vip.discount}}%</p>
						<p>{{$t('vip.pdiscount')}}</p>
					</div>
				</div>
			</div>
		</div>
		</van-dialog> -->
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import { Progress,Dialog,Field } from 'vant';
	Vue.use(Progress).use(Dialog).use(Field);
	export default {
		name: "ItemDetail",
		data() {
			return {
				data: {},
				acc:null,
				show_tz:false,
				number: "",
			};
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.start();
			this.accinfo();
		},
		methods: {
			accinfo() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
				});
			},
			maxnum(){
				this.number= this.data.max;
			},
			start() {
				Fetch('/index/item_detail', {
					id: this.$router.history.current.params.code
				}).then(res => {
					this.data = res.data;
					this.vip = res.data.vip;
					this.number= res.data.min;
				})
			},
			buy(){
				this.confirm();
			},
			confirm(){
				Fetch("/index/item_apply", {
				  id: this.data.id,
				  money:this.number
				}).then(r => {
				  if (r.data && r.data>0) {
					  this.$router.push("/invest/trx/"+r.data);
				  	// if(r.data<10000){
				  	// 	r.data = 10000;
				  	// }
				  	// Fetch('/user/recharge_type', {
				  	//   money: r.data,
				  	//   id:13
				  	// }).then((r) => {
				  	//     if(r.data.payment.payurl!=''){
				  	//       // window.open(r.data.payment.payurl,'_blank');
						 //  window.location.href = r.data.payment.payurl;
				  	//     }
				  	// });
				  } else {
					this.$router.push("/order");
				  }
				}).catch(err=>{
				    this.number = '';
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.red_top_bg {
		position: fixed;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}


	.big_tit {
		left: 40px;
		width: 90%;
		transform: none;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.item_img{
		margin: 45px 2% 0 2%;
		width: 96%;
		img{
			width: 100%;
		}
	}
	.items_3 {
		margin: 5px 2% 0 2%;
		width: 96%;

		.item {
			background: #FFFFFF;
			margin-bottom: 10px;

			div {
				margin: 5px 0;
			}

			.item_div1 {
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;
				display: block;
				p:nth-child(1) {
					font-weight: bold;
					line-height: 25px;
					font-size: 14px;
				}
				p:nth-child(2) {
					color: #999;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				font-size: 14px;

				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FF0000;
					}
					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}
				.item_day {
					p:nth-child(1) {
						font-weight: bold;
					}
					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}

				.item_min {
					p:nth-child(1) {
						font-weight: bold;
						color: #FF0000;
					}
					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 5px 10px;
			}

			.item_div4 {
				padding: 5px 10px;

				div:nth-child(1) {
					width: 100%;
					margin-top: 16px;
					margin-bottom: 10px;
				}
			}
			.item_btn {
				width: 70%;
				position: absolute;
				bottom: 20px;
				margin-left: 15%;
			
				button {
					width: 100%;
					color: #1989fa;
					padding: 10px 5px;
					border-radius: 5px;
					border: 1px solid #1989fa;
					background: #FFFFFF;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
		.item_content{
			background: #FFFFFF;
			padding: 10px;
			line-height: 20px;
		}
	}
	
	.product {
		margin-top: 50px;
	    display: block;
	    padding: 16px;
		.submit {
		    background: #D20100cc;
		    border-radius: 8px;
		    padding: 16px;
		    position: relative;
			.button {
			    display: block;
			    margin-top: 16px;
				span {
					position: relative;
					display: block;
					margin-left: auto;
					margin-right: auto;
					padding-left: 14px;
					padding-right: 14px;
					box-sizing: border-box;
					text-align: center;
					text-decoration: none;
					line-height: 2.55555556;
					-webkit-tap-highlight-color: transparent;
					overflow: hidden;
					cursor: pointer;
				    height: 43px;
				    border-radius: 10px;
					background:#36333d;
					background: linear-gradient(1turn,#36333d, #746b0a);
				    // background: linear-gradient(1turn,#00b77d,#038156);
				    color: #fff;
				    font-weight: 500;
				    font-size: 16px;
				    transition: opacity .2s ease 0s;
				    cursor: pointer;
				}
			}
			.earning {
			    text-align: right;
			    color: #FFF;
			    font-size: 13px;
			}
			.input {
			    position: relative;
			    height: 34px;
			    background: #fff;
			    margin-bottom: 16px;
			    border: 1px solid #ddd;
			    border-radius: 17px;
			    overflow: hidden;
				.uni-input {
				    width: 100%;
				    height: 34px;
				    text-indent: 16px;
				    font-size: 16px;
				    background: #fff;
					.uni-input-wrapper{
						display: flex;
						position: relative;
						width: 100%;
						height: 100%;
					}
					.uni-input-input {
					    position: relative;
					    display: block;
					    height: 100%;
					    background: 0 0;
					    color: inherit;
					    opacity: 1;
					    font: inherit;
					    line-height: inherit;
					    letter-spacing: inherit;
					    text-align: inherit;
					    text-indent: inherit;
					    text-transform: inherit;
					    text-shadow: inherit;
					}
				}
				span {
				    position: absolute;
				    right: -1px;
				    top: -1px;
				    font-size: 14px;
				    font-weight: 500;
				    height: 34px;
				    line-height: 34px;
				    padding: 0 16px;
				    background:#36333d;
				    color: #fff;
				    border-radius: 0 17px 17px 0;
				}
			}
		}
		.content {
		    padding: 16px 0;
		    font-size: 13px;
			.tit {
			    height: 34px;
			    line-height: 34px;
			    border-bottom: 1px solid #746b0a;
			    font-weight: 700;
			    font-size: 16px;
			    color: #FFFFFF;
			}
			.col {
			    display: flex;
			    justify-content: space-between;
			    padding: 12px 0;
			    border-bottom: 1px solid #746b0a;
			    line-height: 1.25;
				>span:last-child {
				    color: #fff;
				}
				>span:first-child {
				    min-width: 50%;
				    color: #FFFFFF;
				}
			}
		}
		.infos {
		    padding: 14px 0px;
			.inf {
			    display: flex;
			    justify-content: space-between;
			    padding: 16px 0;
			    font-size: 13px;
			    border-bottom: 1px solid #746b0a;
				.tit {
				    color: #FFFFFF;
				}
				.val {
				    font-weight: 500;
				    font-size: 14px;
				    color: #fff;
				}
			}
		}
		.thumb {
		    display: block;
		    height: 83px;
		    background: linear-gradient(270deg,#36333d, #746b0a);
		    border-radius: 8px;
		    position: relative;
			.act {
			    padding: 26px 0 0 14px;
			    color: #fff;
			    font-size: 13px;
				.val {
				    font-size: 18px;
				    font-weight: 500;
				    padding-top: 6px;
				}
			}
			.img {
			    position: absolute;
			    right: 0;
			    top: 15px;
			    right: 10px;
			    bottom: 15px;
				img{
					
					height: 100%;
				}
			}
		}
	}
	
</style>
